import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WebCompany } from "src/app/models";
import { CompanyService } from "src/app/services";
import { EmailListData, EmailListDialogComponent } from "../email-list-dialog/email-list-dialog.component";
import { TheMaskedEmail } from "../email-list-dialog/TheMaskedEmail";
import { AbstractControl } from "@angular/forms";
import { FormValidationService } from "src/app/services/form-validation.service";

@Component({
  selector: 'app-temp-password-email-dialog',
  templateUrl: './temp-password-email-dialog.component.html',
  styleUrls: ['./temp-password-email-dialog.component.scss']
})
export class TempPasswordEmailDialogComponent implements OnInit
{

  public emails: TheMaskedEmail[] = [];
  public webEmail: string;
  public company: WebCompany;
  public selectedEmail!: TheMaskedEmail;

  constructor(
    public dialogRef: MatDialogRef<TempPasswordEmailDialogComponent>,
    private companyService: CompanyService,
    private formValidationService: FormValidationService,
    @Inject(MAT_DIALOG_DATA) public data: EmailListData) { }

   public checkFormValidity(form: AbstractControl): void
  {
    form?.markAllAsTouched();

    if (this.formValidationService.checkFormValidity(form)) 
    {
      this.dialogRef.close(this.selectedEmail);
    }
  }

  ngOnInit(): void {
    this.data.emails?.forEach(e => {
      let email = new TheMaskedEmail(e);
      this.emails.push(email);
    });
    this.companyService.company.subscribe(c =>
    {
      this.company = c;

      this.webEmail = this.company.WebEmail ? this.company.WebEmail : this.company.CorpEmail;

    });
  }

  handleCloseClick(): void
  {
    this.dialogRef.close();
  }

}
